import { render, staticRenderFns } from "./customerAssigned.vue?vue&type=template&id=0b24cfd4&scoped=true"
import script from "./customerAssigned.vue?vue&type=script&lang=js"
export * from "./customerAssigned.vue?vue&type=script&lang=js"
import style0 from "./customerAssigned.vue?vue&type=style&index=0&id=0b24cfd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24cfd4",
  null
  
)

export default component.exports